import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-i-position",
  "use": "icon-i-position-usage",
  "viewBox": "0 0 44 44",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 44 44\" id=\"icon-i-position\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h44v44H0z\" /><path d=\"M12.833 11V5.5c0-1.013.821-1.833 1.834-1.833h14.666c1.013 0 1.834.82 1.834 1.833V11H38.5c1.013 0 1.833.82 1.833 1.833V38.5c0 1.013-.82 1.833-1.833 1.833h-33A1.833 1.833 0 0 1 3.667 38.5V12.833c0-1.012.82-1.833 1.833-1.833h7.333Zm-5.5 16.5h29.334v3.667H7.333V27.5ZM16.5 7.333V11h11V7.333h-11Z\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol